import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_storage_desk: FaireCategoryEntity = {
  token: "cat_storage-desk",
  type: "category",
  name: "Desk organization",
  level: 3,
  parentToken: "cat_home-decor-storage",
  href: "/category/home-decor/storage-organization/desk-organization",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
